angular.module('MonstaFTP').filter('file_size', function () {
    return function (input) {
        return normalizeFileSize(input);
    };
});